import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import "./CommonModal.css"
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import CustomInput from '../CustomInput/CustomInput';
import axios from 'axios';
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from 'react-toastify';

function CommonModal({ handleClose, showEdit, state, item, onDataChanged }) {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const userinfo = useSelector((state) => state);

  const location = useLocation();
  const [name, setName] = useState(item && item.name);
  const [grade_id, setSelectedGradeId] = useState("");
  const [semester_id, setSelectedSemesterId] = useState("");
  const [gradeItems, setGradeItems] = useState([]);
  const [max_students, setMax_students] = useState(item && item.max_students)
  const [session_number, setSession_number] = useState(item && item.session_number)
  const [inputValue, setInputValue] = useState(""); // State for input

  const options = [
    { label: currentLocal.home.firstsemster, value: 'first' },
    { label: currentLocal.home.secondsemester, value: 'second' },
  ];






  useEffect(() => {
    const getAllApis = async () => {


      await axios
        .get(`https://nanosoft.space/taarteb/public/api/grades`, {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
          }
        })
        .then(async (res) => {
          const groupedData = res.data.data.data.reduce((acc, item) => {
            const category = item.category;
            if (!acc[category]) {
              acc[category] = [];
            }
            acc[category].push({ label: item.name, value: item.id }); // Set up 'label' and 'value' for react-select
            return acc;
          }, {});

          // Convert grouped data into react-select format
          const selectOptions = Object.keys(groupedData).map(category => ({
            label: category, // Category name
            options: groupedData[category] // Array of options within that category
          }));

          setGradeItems(selectOptions); // Assuming setGradeItems is your state setter


        })
        .catch((error) => {




        });

    }
    getAllApis()

  }, [])
  console.log(userinfo.auth.userArray);

  const handleEdit = async () => {
    if (location.pathname.includes('Subjects')) {
      if (!grade_id || !semester_id) {
        toast.error(currentLocal.home.chooseGradeandSemsterirst, { position: "bottom-right", autoClose: 3000 });

      } else {
        try {
          await axios.put(
            `https://nanosoft.space/taarteb/public/api/subjects/${item.id}`,
            {
              'name': name,
              'grade_id': grade_id.value,
              'semester': semester_id.value,
            },
            {
              headers: {
                Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
              }
            }
          );
          handleClose();
          if (onDataChanged) {
            onDataChanged()
          }
        } catch (error) {
          console.error("Failed to update session:", error);
        }
      }


    } else if (location.pathname.includes('stages')) {
      try {
        const response = await axios.put(`https://nanosoft.space/taarteb/public/api/grade-categories/${item && item.value}`, {
          name: inputValue
        }, {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`

          },
        });
        handleClose()
      } catch (error) {
        toast.error(Object.values(error.response.data.errors.errors)[0][0], { position: "bottom-right", autoClose: 3000 });

      }
    } else {
      if (!grade_id) {
        toast.error(currentLocal.home.chooseGradefirst, { position: "bottom-right", autoClose: 3000 });

      } else {
        try {
          await axios.put(
            `https://nanosoft.space/taarteb/public/api/classes/${item.id}`,
            {
              name,
              grade_id: grade_id.value,
              max_students,
              session_number,
            },
            {
              headers: {
                Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
              }
            }
          );
          handleClose();
          if (onDataChanged) {
            onDataChanged()
          }
        } catch (error) {
          console.error("Failed to update session:", error);
        }
      }

    }
  }
  console.log(item);

  useEffect(() => {
    setInputValue(item?.label)
  }, [])

  return (
    <Modal show={showEdit} onHide={handleClose} centered>
      <ToastContainer />

      <Modal.Body>
        {location.pathname.includes('Subjects') &&
          <>

            <div>
              <label>{currentLocal.home.namePlaceholder}</label>
              <CustomInput
                placeholder={currentLocal.home.namePlaceholder}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <label>{currentLocal.home.grades}</label>
            <br />
            <div className='mb-3'>
              <Select
                value={grade_id}
                onChange={(selectedOption) => setSelectedGradeId(selectedOption)}
                options={gradeItems}
                placeholder={currentLocal.home.SelectGrades}

              />
            </div>

            <div>
              <label>{currentLocal.home.Semester}</label>
              <br />
              <div className='mb-3'>
                <Select
                  value={semester_id}
                  onChange={(selectedOption) => setSelectedSemesterId(selectedOption)}
                  options={options}
                  placeholder={currentLocal.home.SelectSemester} // Change this text

                />
              </div>
            </div>
          </>

        }
        {location.pathname.includes('Classes') &&
          <>

            <div>
              <label>{currentLocal.home.namePlaceholder}</label>
              <CustomInput
                placeholder={currentLocal.home.namePlaceholder}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <label>{currentLocal.home.grades}</label>
            <br />
            <div className='mb-3'>
              <Select
                value={grade_id}
                onChange={(selectedOption) => setSelectedGradeId(selectedOption)}
                options={gradeItems}
                placeholder={currentLocal.home.SelectGrades}

              />
            </div>

            <div>
              <label>{currentLocal.home.MaxStudents}</label>
              <CustomInput
                placeholder={currentLocal.home.MaxStudents}
                value={max_students}
                onChange={(e) => setMax_students(e.target.value)}
              />
            </div>
            <div>
              <label> {currentLocal.home.sessionnumber}</label>
              <CustomInput
                placeholder={currentLocal.home.sessionnumber}
                value={session_number}
                onChange={(e) => setSession_number(e.target.value)}
              />
            </div>
          </>

        }
        {location.pathname.includes('grades') &&
          <div>

            <label>{currentLocal.home.stageName}</label>
            <div className='w-100 position-relative'>
              <Select
                value={grade_id}
                onChange={(selectedOption) => setSelectedGradeId(selectedOption)}
                options={gradeItems}
                placeholder={currentLocal.home.SelectStage}

              />
            </div>
          </div>
        }
        {location.pathname.includes('stage') &&
          <div>

            <label className="text-mutedx">{location.pathname.includes("stages") ? currentLocal.home.stageName : currentLocal.home.gradeName}</label>

            <CustomInput
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </div>
        }
      </Modal.Body>
      <Modal.Footer>
        <div className='d-flex justify-content-center w-100'>
          <Button variant="primary" onClick={handleEdit} className='mx-3'>
            {state}
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            {currentLocal.home.close}
          </Button>

        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default CommonModal
